export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9341.c5f6a645.jpg";